export default function getMediaGroupNodeView(schema, filename, context) {
    if (context === void 0) { context = {}; }
    var _a = schema.nodes, media = _a.media, mediaGroup = _a.mediaGroup;
    // try to look up media ID from conversion context
    var id = context.conversion &&
        context.conversion.mediaConversion &&
        context.conversion.mediaConversion[filename]
        ? context.conversion.mediaConversion[filename]
        : filename;
    // try to look up collection from media context
    var collection = context.hydration &&
        context.hydration.media &&
        context.hydration.media.targetCollectionId;
    var mediaNode = media.createChecked({
        id: id,
        type: 'file',
        collection: collection || '',
    });
    return mediaGroup.createChecked({}, mediaNode);
}
//# sourceMappingURL=mediaGroup.js.map